/* unplugin-vue-components disabled */import { render } from "./AudioTrackLoader.vue?vue&type=template&id=148476f3&scoped=true&ts=true"
import script from "./AudioTrackLoader.vue?vue&type=script&lang=ts"
export * from "./AudioTrackLoader.vue?vue&type=script&lang=ts"

import "./AudioTrackLoader.vue?vue&type=style&index=0&id=148476f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148476f3"]])

export default __exports__